// @flow
/* eslint-disable react/jsx-indent */

import React from 'react';
import { toastr } from 'react-redux-toastr';

import styles from './collectionsHandoverPendingModal.scss';

import Modal from '../modal/modal';
import ZoomTable from '../zoomTable/zoomTable';
import SearchBox from '../searchBox/searchBox';
import Loader from '../loader/loader';
import PrintCollectionHandover from '../printPages/printCollectionHandover';
import DenominationReciept from '../../commons/denominationReciept/denominationReciept';

import { roundOff } from '../../../services/helpers';

const successTickIcnUrl = require('../../../assets/images/success-tick.png');

type Props = {
  showModal: boolean,
  closeModal: Function,
  cnWiseData: Object,
  tableKey: string,
  title: string,
  initiateHandoverMethod: Function,
  handoverObject: Object,
  selectedUser: Object,
  userProfile: Object,
  resetHandoverProp: Function,
  showHandoverDetailsModal: Function,
  writeOffObject: Object,
  initiateWriteOffMethod: Function
};

type State = {
  resetSearchText: boolean,
  screenToShow: number,
  cnWiseData: Object,
  selectedCNs: Array<Object>,
  summarycard: Object,
  selectedSummaryCard: Object,
  modalTheme: Object,
  printData: Object,
  printHandover: boolean
  // isClosed: boolean
};

class CollectionsHandoverPendingModal extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.searchTimeoutId = null;
    this.state = {
      resetSearchText: false,
      screenToShow: 1,
      cnWiseData: {
        tableData: []
      },
      selectedCNs: [],
      summarycard: {
        cash: 0,
        cashTotal: 0,
        cheque: 0,
        chequeTotal: 0
      },
      selectedSummaryCard: {
        cash: 0,
        cashTotal: 0,
        cheque: 0,
        chequeTotal: 0
      },
      modalTheme: {
        name: 'themeBlack',
        titleCenter: true,
        showBackBtn: true,
        closeIcnWhite: true
      },
      printData: null,
      handoverSlips: null,
      denominationDetails: null,
      grandTotalofDenomination: 0,
      isGrandTotalofDenominationValid: null,
      printHandover: false
      // isClosed: false
    };
    this.tableActionFunctions = {
      RTL_COLLECTIONS_HANDOVER_CN_WISE: {
        selectCn: rowData => {
          const indexInSelectedCnArray = this.state.selectedCNs.indexOf(
            rowData
          );
          const selectedCNsLocal = this.state.selectedCNs;
          let updatedCnWiseData = Object.assign({}, this.state.cnWiseData);
          if (indexInSelectedCnArray === -1) {
            selectedCNsLocal.push(rowData);
            updatedCnWiseData = this.updateTableDataAfterSelection(rowData);
          } else {
            selectedCNsLocal.splice(indexInSelectedCnArray, 1);
            updatedCnWiseData = this.updateTableDataAfterDeselection(rowData);
          }
          const selectedSummaryCard = this.calculateSummaryComponents(
            selectedCNsLocal
          );
          this.setState({
            selectedSummaryCard,
            selectedCNs: selectedCNsLocal,
            cnWiseData: updatedCnWiseData
          });
        }
      }
    };
    this.updateDenominationDetails = this.updateDenominationDetails.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.screenToShow === 1 && this.props.showModal) {
      this.setCnWiseData(nextProps);
    }
    if (this.state.screenToShow === 2) {
      this.setStateAfterHandoverOrWriteOffInitiateCall(nextProps);
    }
  }

  onSearchValueChange(val: string) {
    // Shut up and debounce!
    if (this.searchTimeoutId !== null) {
      clearTimeout(this.searchTimeoutId);
    }
    this.searchTimeoutId = setTimeout(
      this.filterTableData.bind(this, val),
      1000
    ); // Perform search after 1 second
  }

  setCnWiseData(nextProps) {
    this.setState(
      {
        cnWiseData: nextProps.cnWiseData
      },
      () => {
        this.defaultSelectAll();
        this.setSummaryCard(nextProps);
      }
    );
    this.originalTableData = nextProps.cnWiseData.tableData;
  }

  setSummaryCard(nextProps) {
    const tableData =
      nextProps && nextProps.cnWiseData && nextProps.cnWiseData.tableData;
    const summarycard = this.calculateSummaryComponents(tableData);
    this.setState({
      summarycard
    });
  }

  getHandoverSlipList(printData) {
    const totalCash = this.state && this.state.selectedSummaryCard.cashTotal;
    const denomination = this.state && this.state.denominationDetails;
    let cashHandoverId = null;
    let cashTotalCNs = 0;
    const handoverSlipList = [];
    printData.consignmentHandoverDTOList.forEach(cn => {
      if (cn.paymentType === 'Cheque') {
        handoverSlipList.push({
          paymentType: 'Cheque',
          handoverId: cn.handoverId,
          totalCn: 1,
          handoverAmount: cn.amount,
          chequeNumber: cn.chequeNumber
        });
      } else if (cn.paymentType === 'Cash') {
        if (!cashHandoverId) {
          cashHandoverId = cn.handoverId;
        }
        cashTotalCNs += 1;
      }
    });
    if (!cashTotalCNs) {
      return handoverSlipList;
    }
    const cashHandoverSlip = {
      paymentType: 'Cash',
      handoverId: cashHandoverId,
      totalCn: cashTotalCNs,
      handoverAmount: totalCash,
      denomination: denomination || {}
    };
    return [cashHandoverSlip, ...handoverSlipList];
  }

  setStateAfterHandoverOrWriteOffInitiateCall(nextProps) {
    if (
      nextProps.handoverObject.callInitiated &&
      nextProps.handoverObject.callSuccess &&
      nextProps.handoverObject.callCompleted
    ) {
      this.setState({
        screenToShow: 3,
        modalTheme: {
          name: 'themeBlack',
          titleCenter: true,
          showBackBtn: false,
          closeIcnWhite: true
        },
        printData: nextProps.handoverObject.printData,
        handoverSlips: this.getHandoverSlipList(
          nextProps.handoverObject.printData
        )
      });
    } else if (
      nextProps.handoverObject.callInitiated &&
      !nextProps.handoverObject.callSuccess &&
      nextProps.handoverObject.callCompleted &&
      nextProps.handoverObject.error &&
      this.state.screenToShow === 2
    ) {
      toastr.error(
        'Error',
        nextProps.handoverObject.error || 'Could not initiate handover'
      );
    } else if (
      nextProps.writeOffObject.callInitiated &&
      nextProps.writeOffObject.callSuccess &&
      nextProps.writeOffObject.callCompleted
    ) {
      this.setState({
        screenToShow: 3,
        modalTheme: {
          name: 'themeBlack',
          titleCenter: true,
          showBackBtn: false,
          closeIcnWhite: true
        },
        printData: nextProps.writeOffObject.printData,
        handoverSlips: this.getHandoverSlipList(
          nextProps.handoverObject.printData
        )
      });
    } else if (
      nextProps.writeOffObject.callInitiated &&
      !nextProps.writeOffObject.callSuccess &&
      nextProps.writeOffObject.callCompleted &&
      nextProps.writeOffObject.error &&
      this.state.screenToShow === 2
    ) {
      toastr.error(
        'Error',
        nextProps.writeOffObject.error || 'Could not initiate writeOff'
      );
    }
  }

  getSummaryCardTotal() {
    return roundOff(
      this.state.selectedSummaryCard.cashTotal +
        this.state.selectedSummaryCard.chequeTotal
    );
  }

  defaultSelectAll() {
    const tableDataClone =
      this.state.cnWiseData &&
      this.state.cnWiseData.tableData &&
      this.state.cnWiseData.tableData.length
        ? this.state.cnWiseData.tableData
        : [];
    const selectedCNsClone = [];
    tableDataClone.map(row => {
      if (row.handoverStatus !== 'WRITE_OFF_PENDING') {
        row.selected = true;
        selectedCNsClone.push(row);
        return row; // for eslint
      }
      return null;
    });
    const cnWiseDataUpdated = Object.assign({}, this.state.cnWiseData, {
      tableData: tableDataClone
    });
    const selectedSummaryCard = this.calculateSummaryComponents(tableDataClone);
    this.setState({
      cnWiseData: cnWiseDataUpdated,
      selectedCNs: selectedCNsClone,
      selectedSummaryCard
    });
  }

  filterTableData(searchString) {
    const { tableData } = this.state.cnWiseData;
    const searchStrLower = searchString.toLowerCase().trim();

    let filteredRes;

    if (searchStrLower) {
      filteredRes = tableData.filter(
        row =>
          (row.cnote && row.cnote.toLowerCase().indexOf(searchStrLower) >= 0) ||
          (row.clientUserName &&
            row.clientUserName.toLowerCase().indexOf(searchStrLower) >= 0) ||
          (row.paymentType &&
            row.paymentType.toLowerCase().indexOf(searchStrLower) >= 0) ||
          (row.bankName &&
            row.bankName.toLowerCase().indexOf(searchStrLower) >= 0) ||
          (row.chequeNumber &&
            row.chequeNumber.toLowerCase().indexOf(searchStrLower) >= 0)
      );
    } else {
      filteredRes = this.originalTableData;
    }
    const updatedCnWiseData = Object.assign({}, { tableData: filteredRes });
    this.setState({
      cnWiseData: updatedCnWiseData
    });
  }

  resetSearchText() {
    const updatedCnWiseData = Object.assign(
      {},
      { tableData: this.originalTableData }
    );
    this.setState({
      cnWiseData: updatedCnWiseData
    });
  }

  calculateSummaryComponents(tableData) {
    const summary = { cash: 0, cashTotal: 0, cheque: 0, chequeTotal: 0 };
    if (tableData && tableData.length) {
      tableData.map(ob => {
        if (ob.paymentType === 'Cash') {
          summary.cash += 1;
          summary.cashTotal += ob.amount;
          summary.cashTotal = roundOff(summary.cashTotal, 2);
        } else if (ob.paymentType === 'Cheque') {
          summary.cheque += 1;
          summary.chequeTotal += ob.amount;
          summary.chequeTotal = roundOff(summary.chequeTotal, 2);
        }
        return ob; // only for eslint
      });
    }
    return summary;
  }

  updateTableDataAfterSelection(rowData) {
    const rowIndex = this.state.cnWiseData.tableData.indexOf(rowData);
    const { tableData } = this.state.cnWiseData;
    tableData[rowIndex].selected = true;
    const updatedCnWiseData = Object.assign({}, { tableData });
    return updatedCnWiseData;
    // this.setState({
    //   cnWiseData: updatedCnWiseData
    // });
  }

  updateTableDataAfterDeselection(rowData) {
    const rowIndex = this.state.cnWiseData.tableData.indexOf(rowData);
    const { tableData } = this.state.cnWiseData;
    tableData[rowIndex].selected = false;
    const updatedCnWiseData = Object.assign({}, { tableData });
    return updatedCnWiseData;
    // this.setState({
    //   cnWiseData: updatedCnWiseData
    // });
  }

  handleHandoverSummaryBack() {
    if (this.state.screenToShow === 2) {
      // This is the confirm handover initiation screen.
      this.setState({
        screenToShow: 1,
        modalTheme: {
          name: 'themeBlack',
          titleCenter: true,
          showBackBtn: true,
          closeIcnWhite: true
        }
      });
    }

    if (this.state.screenToShow === 1) {
      // This is the confirm handover initiation screen.
      this.props.showHandoverDetailsModal();
    }
  }

  closeModal() {
    this.setState(
      {
        resetSearchText: false,
        screenToShow: 1,
        cnWiseData: {
          tableData: []
        },
        selectedCNs: [],
        summarycard: {
          cash: 0,
          cashTotal: 0,
          cheque: 0,
          chequeTotal: 0
        },
        selectedSummaryCard: {
          cash: 0,
          cashTotal: 0,
          cheque: 0,
          chequeTotal: 0
        },
        printData: null,
        handoverSlips: null,
        denominationDetails: null,
        grandTotalofDenomination: 0,
        isGrandTotalofDenominationValid: null,
        printHandover: false
        // isClosed: true
      },
      () => {
        this.props.closeModal(false, true); // 1st param is to close modal, 2nd is to refresh, 3rd is to reset handoverprops
        // this.props.resetHandoverProp();
      }
    );
  }

  initiateHandover() {
    if (!this.state.selectedCNs.length) {
      toastr.error('Error', 'Please select CNs for handover');
      return;
    }
    if (
      roundOff(this.state.selectedSummaryCard.cashTotal) !==
      this.state.grandTotalofDenomination
    ) {
      toastr.error('Error', 'Please select correct denomination');
      return;
    }
    this.setState({
      screenToShow: 2,
      modalTheme: {
        name: 'themeBlack',
        titleCenter: true,
        showBackBtn: true,
        closeIcnWhite: true
      }
    });
  }

  initiateWriteOff() {
    if (!this.state.selectedCNs.length) {
      toastr.error('Error', 'Please select CNs for write off');
      return;
    }
    this.setState({
      screenToShow: 2,
      modalTheme: {
        name: 'themeBlack',
        titleCenter: true,
        showBackBtn: true,
        closeIcnWhite: true
      },
      isWriteOff: true
    });
  }

  confirmHandoverAndWriteOffSubmission() {
    if (this.state.isWriteOff) {
      this.props.initiateWriteOffMethod({
        userId: this.props.selectedUser.id,
        consignmentHandoverDTOList: this.state.selectedCNs
      });
    } else {
      this.props.initiateHandoverMethod({
        userId: this.props.selectedUser.id,
        consignmentHandoverDTOList: this.state.selectedCNs
      });
    }
  }

  printHandoverSuccess() {
    if (this.state.printData) {
      this.setState({
        printHandover: true
      });
    } else {
      toastr.error('Error', 'Print Data Not Available');
    }
  }

  shouldRenderWriteOffButton() {
    let allCnsWriteOffEligible = true;
    let atleastOneCnWriteOffEligible = false;
    if (this.state.selectedCNs && this.state.selectedCNs.length) {
      this.state.selectedCNs.forEach(cn => {
        if (cn.isWriteOffEligible) {
          atleastOneCnWriteOffEligible = true;
        } else {
          allCnsWriteOffEligible = false;
        }
      });
    }
    return { allCnsWriteOffEligible, atleastOneCnWriteOffEligible };
  }

  renderSuccessFailSection() {
    return (
      <div className={`${styles.handoverSuccessFailWrapper} l-col a-center`}>
        <div className={`${styles.successFailIcn}`}>
          <img src={successTickIcnUrl} alt="Icn" />
        </div>
        {this.state.isWriteOff ? (
          <div className={`${styles.successFailTitle}`}>
            Write off Initiated
          </div>
        ) : (
          <div className={`${styles.successFailTitle}`}>Handover Success</div>
        )}
        <div className={`${styles.successFailMsg}`}>
          Total amount ₹{' '}
          {roundOff(
            this.state.selectedSummaryCard.cashTotal +
              this.state.selectedSummaryCard.chequeTotal
          )}{' '}
          has been handed over to {this.props.userProfile.first_name} by{' '}
          {this.props.selectedUser.name}.
        </div>
        <div
          className={`${styles.printHandoverBtn} printHandoverBtn l-row j-center a-center cursor-p`}
          onClick={() => this.printHandoverSuccess()}
        >
          Print Receipt
        </div>

        {this.state.printHandover &&
        this.state.printData &&
        this.state.handoverSlips ? (
          <PrintCollectionHandover
            printData={this.state.printData}
            handoverSlips={this.state.handoverSlips}
          />
        ) : null}
      </div>
    );
  }

  renderConfirmHandoverSection() {
    return !this.props.handoverObject.callCompleted &&
      this.props.handoverObject.callInitiated ? (
      <div className={`${styles.handoverConfirmationWrapper} l-col a-center`}>
        <Loader />
      </div>
    ) : (
      <div className={`${styles.handoverConfirmationWrapper} l-col a-center`}>
        {this.state.isWriteOff ? (
          <div>
            <div className={`${styles.handoverConfirmationTitle}`}>
              WriteOff Confirmation
            </div>
            <div className={`${styles.handoverConfirmationInfo}`}>
              <div>
                This action will raise a request for write off with Finance
                team. This money can not be recovered. Are you sure?
              </div>
              <div>
                This will add Rs. {this.getSummaryCardTotal()} outstanding in
                your Cashbook after approval from Finance
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className={`${styles.handoverConfirmationTitle}`}>
              Handover Confirmation
            </div>
            <div className={`${styles.handoverConfirmationInfo}`}>
              This will add Rs. {this.getSummaryCardTotal()} outstanding in your
              Cashbook
            </div>
          </div>
        )}

        <div className={`${styles.handoverConfirmationDetails} l-row`}>
          <div className={`${styles.handoverConfirmationDetails1}`}>
            Cash ({this.state.selectedSummaryCard.cash}) : ₹
            {roundOff(this.state.selectedSummaryCard.cashTotal)} + Cheque (
            {this.state.selectedSummaryCard.cheque}) : ₹
            {roundOff(this.state.selectedSummaryCard.chequeTotal)} =
          </div>
          <div className={`${styles.handoverConfirmationDetails2}`}>
            Total : ₹
            {roundOff(
              this.state.selectedSummaryCard.cashTotal +
                this.state.selectedSummaryCard.chequeTotal
            )}
          </div>
        </div>

        <div
          className={`${styles.handoverConfirmaBtn} l-row j-center a-center cursor-p`}
          onClick={() => this.confirmHandoverAndWriteOffSubmission()}
        >
          Confirm
        </div>
      </div>
    );
  }

  checkIfTotalCashAmountEqualToGrandTotal() {
    console.log(
      this.state.selectedSummaryCard,
      this.state.grandTotalofDenomination
    );
    return (
      roundOff(this.state.selectedSummaryCard.cashTotal) ===
      this.state.grandTotalofDenomination
    );
  }

  checkGrandTotalValidity() {
    this.setState({
      isGrandTotalofDenominationValid: this.checkIfTotalCashAmountEqualToGrandTotal()
    });
  }

  updateDenominationDetails(grandTotalofDenomination, denominationDetails) {
    console.log(grandTotalofDenomination, denominationDetails);
    this.setState(
      {
        denominationDetails,
        grandTotalofDenomination
      },
      () => {
        this.checkGrandTotalValidity();
      }
    );
  }

  renderPendingSummarySection() {
    const writeOffDisplayObj = this.shouldRenderWriteOffButton();
    return (
      <div className={`${styles.collectionsHandoverModalWrapper}`}>
        <div
          className={`${styles.pendingSummarySection} l-row a-center  j-space-bet`}
        >
          <div className={`${styles.pendingSummaryLabel}`}>Pending Summary</div>

          <div className={`${styles.pendingDetails} l-row a-center`}>
            <div className={`${styles.detailsSection1}`} />
            Cash ({this.state.summarycard.cash}) : ₹
            {roundOff(this.state.summarycard.cashTotal)} + Cheque (
            {this.state.summarycard.cheque}) : ₹
            {roundOff(this.state.summarycard.chequeTotal)}=
            <div className={`${styles.detailsSection2}`}>
              Total (
              {this.state.summarycard.cash + this.state.summarycard.cheque}) : ₹
              {roundOff(
                this.state.summarycard.cashTotal +
                  this.state.summarycard.chequeTotal
              )}
            </div>
          </div>

          <div className={`${styles.searchBoxParent}`}>
            <SearchBox
              onSearchValueChange={val => this.onSearchValueChange(val)}
              resetSearchText={this.state.resetSearchText}
            />
          </div>
        </div>

        <div className={`${styles.tableSection}`}>
          <ZoomTable
            configKey={this.props.tableKey}
            tableDataLength={
              (this.state.cnWiseData.tableData &&
                this.state.cnWiseData.tableData.length) ||
              0
            }
            tableData={this.state.cnWiseData.tableData || []}
            actionFunctions={this.tableActionFunctions[this.props.tableKey]}
          />
          <div className={`${styles.denominationSection}`}>
            <DenominationReciept
              passDenominationDetailsToParent={this.updateDenominationDetails}
              isGrandTotalValid={this.state.isGrandTotalofDenominationValid}
              isCancellationLoading={true}
              noPadding={true}
            />
          </div>
        </div>

        <div
          className={`${styles.handoverSummarySection} l-row a-center  j-space-bet`}
        >
          <div className={`${styles.handoverSummaryLabel}`}>
            Handover Summary
          </div>

          <div className={`${styles.handoverDetails} l-row a-center`}>
            <div className={`${styles.handoverDetailsSection1}`} />
            Cash ({this.state.selectedSummaryCard.cash}) : ₹
            {roundOff(this.state.selectedSummaryCard.cashTotal)} + Cheque (
            {this.state.selectedSummaryCard.cheque}) : ₹
            {roundOff(this.state.selectedSummaryCard.chequeTotal)}=
            <div className={`${styles.handoverDetailsSection2}`}>
              Total (
              {this.state.selectedSummaryCard.cash +
                this.state.selectedSummaryCard.cheque}
              ) : ₹
              {roundOff(
                this.state.selectedSummaryCard.cashTotal +
                  this.state.selectedSummaryCard.chequeTotal
              )}
            </div>
          </div>
          <div className="l-row a-center j-space-bet">
            {writeOffDisplayObj.atleastOneCnWriteOffEligible ? (
              <div
                className={
                  writeOffDisplayObj.allCnsWriteOffEligible
                    ? `${styles.writeOffBtn} l-row a-center j-center cursor-p`
                    : `${styles.writeOffBtnDisabled} l-row a-center j-center`
                }
                onClick={() => {
                  if (writeOffDisplayObj.allCnsWriteOffEligible) {
                    this.initiateWriteOff();
                  }
                }}
              >
                REQUEST WRITE-OFF
              </div>
            ) : null}
            <div
              className={`${styles.initiateBtn} l-row a-center j-center cursor-p`}
              onClick={() => this.initiateHandover()}
            >
              INITIATE
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderScreens() {
    if (this.state.screenToShow === 3) {
      return this.renderSuccessFailSection();
    }
    if (this.state.screenToShow === 2) {
      return this.renderConfirmHandoverSection();
    }
    if (this.state.screenToShow === 1) {
      return this.renderPendingSummarySection();
    }
    return null;
  }

  render() {
    return (
      <Modal
        showLoader={this.props.cnWiseData.isLoading}
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={() => {
          this.closeModal();
        }}
        modalTheme={this.state.modalTheme}
        onBackBtnClick={() => this.handleHandoverSummaryBack()}
      >
        {// eslint-disable-next-line
        console.log(' cnWiseData: ', this.state.cnWiseData)}
        <div style={{ paddingBottom: '6rem' }}>{this.renderScreens()}</div>
      </Modal>
    );
  }
}

export default CollectionsHandoverPendingModal;
